import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import { LoginPage } from "@/pages/Login";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { ChatView } from "@/pages/Chat";
import { ProjectsList } from "@/pages/Projects";
import { CronPage } from "@/pages/Cron";
import { InboxPage } from "@/pages/Inbox";

export default function App() {
  const { user, loading, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-700 border-t-blue-500" />
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route index element={<ChatView />} />
        <Route path="projects" element={<ProjectsList />} />
        <Route path="projects/:id" element={<ChatView />} />
        <Route path="cron" element={<CronPage />} />
        <Route path="inbox" element={<InboxPage />} />
      </Route>
      <Route path="login" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
